<div class="header-main" [ngSwitch]="ctx.HeaderTemplate">
    <app-header-default [ctx]="ctx" *ngSwitchDefault></app-header-default>
    <app-header-pro-parts [ctx]="ctx" *ngSwitchCase="'proparts'"></app-header-pro-parts>
    <app-header-doetam [ctx]="ctx" *ngSwitchCase="'doetam'"></app-header-doetam>
    <app-header-twimva [ctx]="ctx" *ngSwitchCase="'twimva'"></app-header-twimva>
    <app-header-hofland [ctx]="ctx" *ngSwitchCase="'hofland'"></app-header-hofland>
    <app-header-star-old [ctx]="ctx" *ngSwitchCase="'star_old'"></app-header-star-old>
    <app-header-star [ctx]="ctx" *ngSwitchCase="'star'"></app-header-star>
    <app-header-webshop [ctx]="ctx" *ngSwitchCase="'webshop'"></app-header-webshop>
</div>